/*global google*/
import React from 'react'
import { InputSelectOption } from '@sharedComponents/InputSelect/types'
import i18n from '../Shared/translation/i18n'
import RecyclingOption from '../PexMap/RecyclingOptions/RecyclingOption'
import { rawSizes } from '../Shared/Utils/MediaQueries'
import forEach from 'lodash/forEach'
import filter from 'lodash/filter'
import includes from 'lodash/includes'
import { RecyclingStationItem } from '../Shared/Services/RecyclingStations/interfaces'

export const MapStyles: google.maps.MapTypeStyle[] = [
    {
        featureType: 'landscape',
        stylers: [{ color: `#f2f2f2` }],
    },
    {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{ color: `#fffffa` }],
    },
    {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry',
        stylers: [{ saturation: -100 }],
    },
    {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [{ color: `#fffffa` }],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ saturation: -100 }],
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ saturation: -100 }],
    },
    {
        featureType: 'transit',
        stylers: [{ color: `#f2f2f2` }],
    },
    {
        featureType: 'water',
        stylers: [{ color: `#59c2de` }],
    },
]

export const MapContainerStyles = {
    width: '100%',
    height: '46.875rem',
}

export const MapCenter = {
    lat: 59.5905308,
    lng: 15.1884184,
}

export const ClusterOptions = {
    imagePath: '',
}

export const ClusterStyles = [
    { height: 30, width: 30, url: '' },
    { height: 40, width: 40, url: '' },
    { height: 50, width: 50, url: '' },
    { height: 60, width: 60, url: '' },
]

export const getStyleForCluster = (nrOfMarkersInCluster: number) => {
    if (nrOfMarkersInCluster >= 1000) {
        return 4
    } else if (nrOfMarkersInCluster >= 100) {
        return 3
    } else if (nrOfMarkersInCluster >= 10) {
        return 2
    }
    return 1
}

export enum IconForOption {
    Rvm = 'pantautomat',
    BigRvm = 'pantbag_x3',
    Pex = 'pex',
    RecyclingStation = 'pallet',
    CommunityBagsStation = 'bag',
}

export const formatRecyclingOptions = (options: string[]) => {
    const formatted: InputSelectOption[] = [];
    options.forEach(option => {
        const labelContent = (
            <RecyclingOption
                key={`select-option-${option}`}
                label={i18n.t(`recyclingStations.options.label.${option}`)}
                description={i18n.t(
                    `recyclingStations.options.description.${option}`
                )}
                iconName={IconForOption[option as keyof typeof IconForOption]}
            />
        )
        formatted.push({
            value: option,
            label: labelContent,
        });
    })
    return formatted;
}

export const formatSelectedString = (selection: InputSelectOption[]) => {
    if (selection && selection.length > 0) {
        const selectedStrings = selection.map(item =>
            i18n.t(`recyclingStations.options.label.${item.value}`)
        )
        return selectedStrings.join(', ');
    }
    return '—';
}

export const getInfoWindowOptions = () => {
    const isMobile = rawSizes.sm > window.innerWidth;
    const isMobileLg =
        rawSizes.md > window.innerWidth && window.innerWidth >= rawSizes.sm;
    let maxWidth = isMobile ? 300 : 720;
    maxWidth = isMobileLg ? 450 : maxWidth;
    const pixelOffset =
        isMobile || isMobileLg
            ? new google.maps.Size(0, 275)
            : new google.maps.Size(-400, 350);
    return {
        maxWidth: maxWidth,
        pixelOffset: pixelOffset,
    }
}

export const hasMarkersInViewport = (
    stations: RecyclingStationItem[],
    viewport: any
) => {
    let hasMarkers = false;
    forEach(stations, station => {
        if (viewport.contains({ lat: Number(station.lat), lng: Number(station.lng) })) {
            hasMarkers = true;
            return false;
        }
        return;
    })
    return hasMarkers;
}

export const fitMapToClosestMarker = (
    stations: RecyclingStationItem[],
    viewport: any,
    map: google.maps.Map
) => {
    let hasMarkers = hasMarkersInViewport(stations, viewport);
    while (!hasMarkers && map) {
        const zoom = map.getZoom();
        if (zoom) {
            map.setZoom(zoom - 1);
        }
        hasMarkers = hasMarkersInViewport(stations, map?.getBounds());
    }
}

export const filterRecyclingStations = (
    selected: InputSelectOption[],
    stations: RecyclingStationItem[]
) => {
    const newFiltered = filter(stations, station => {
        let res = false;
        forEach(selected, item => {
            res = res || includes(station.categories, item.value);
        })
        return res;
    })
    return newFiltered;
}
